import { useAppDispatch } from "../../../../redux/hooks";
import ActionMenu, {
  ActionMenuItem,
} from "../../../../components/actionMenu/ActionMenu";
import { BinHistoryDataInterface } from "../../../../redux/interfaces/expedition.interface";
import {
  fetchPrintBinA4,
  fetchPrintBinZebra,
} from "../../../../redux/api/expedition.api";

function BinHistoryActionButton({
  itemId,
}: {
  itemId: string;
  crudData: BinHistoryDataInterface;
}) {
  const dispatch = useAppDispatch();

  const handlePrintBinA4 = () => {
    if (itemId) {
      dispatch(
        fetchPrintBinA4({
          idBin: itemId,
        }),
      );
    }
  };

  const handlePrintBinZebra = () => {
    if (itemId) {
      dispatch(
        fetchPrintBinZebra({
          idBin: itemId,
        }),
      );
    }
  };

  const items: ActionMenuItem[] = [
    {
      id: "print-a4",
      label: "Print A4",
      icon: "DOCUMENTS",
      kind: "print",
      tooltip: itemId
        ? "Deschide eticheta binului pentru imprimare A4."
        : "Binul trebuie sa aiba un identificator pentru imprimare.",
      disabled: !itemId,
      onClick: handlePrintBinA4,
    },
    {
      id: "print-zebra",
      label: "Print Zebra",
      icon: "LABEL",
      kind: "print",
      tooltip: itemId
        ? "Deschide eticheta binului pentru imprimanta Zebra."
        : "Binul trebuie sa aiba un identificator pentru imprimare.",
      disabled: !itemId,
      onClick: handlePrintBinZebra,
    },
  ];

  return (
    <ActionMenu
      items={items}
      title={`Bin ${itemId}`}
      ariaLabel={`Actiuni pentru binul ${itemId}`}
    />
  );
}

export default BinHistoryActionButton;
